import { render } from "./UserLog.vue?vue&type=template&id=c3455c1a&scoped=true&ts=true"
import script from "./UserLog.vue?vue&type=script&lang=ts"
export * from "./UserLog.vue?vue&type=script&lang=ts"

import "./UserLog.vue?vue&type=style&index=0&id=c3455c1a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3455c1a"]])

export default __exports__